export default __webpack_public_path__ + "static/media/folder-vector.5dff1743.svg";